import { render } from "./ClocklogsReport.vue?vue&type=template&id=267f3f52"
import script from "./ClocklogsReport.vue?vue&type=script&lang=js"
export * from "./ClocklogsReport.vue?vue&type=script&lang=js"

import "./ClocklogsReport.vue?vue&type=style&index=0&id=267f3f52&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__